import React from 'react'
import styled from '@emotion/styled'
import Img from 'gatsby-image'
import { useStaticQuery, graphql } from 'gatsby'
import Marquee from 'react-fast-marquee'
import Heading from '~/components/Heading'
import { breakpoints } from '../../utils/styles'
import Wiggle from '~/icons/Wiggle'

import Facebook from '~/icons/Facebook'
import Twitter from '~/icons/Twitter'
import Instagram from '~/icons/Instagram'
import TikTok from '~/icons/TikTok'

const InstagramFeed = props => {
  const data = useStaticQuery(
    graphql`
      query {
        one: file(relativePath: { eq: "instagram/1.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        two: file(relativePath: { eq: "instagram/2.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        three: file(relativePath: { eq: "instagram/3.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        four: file(relativePath: { eq: "instagram/4.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `
  )

  const feed = [
    {
      url: 'https://www.instagram.com/p/CQy7FVTpy5I/',
      key: 'one',
    },
    {
      url: 'https://www.instagram.com/p/CLCHQzZJW8V/',
      key: 'two',
    },
    {
      url: 'https://www.instagram.com/p/CLeVRjKHSbn/',
      key: 'three',
    },
    {
      url: 'https://www.instagram.com/theablevegan/',
      key: 'four',
    },
  ]

  return (
    <>
      <Wrapper {...props}>
        <Heading mobileFontSize="32px">
          Get social{' '}
          <span>
            <a
              href="https://instagram.com/getnooro"
              target="_blank"
              rel="noreferrer"
            >
              @getnooro
            </a>
          </span>
        </Heading>
        <Grid>
          {feed.map((item, i) => {
            return (
              <a
                key={`instagram-${i}`}
                href={item.url}
                target="_blank"
                rel="noreferrer"
              >
                <Img fluid={data[item.key].childImageSharp.fluid} />
              </a>
            )
          })}
        </Grid>
        <Icons>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://instagram.com/getnooro"
          >
            <Instagram width={50} height={50} />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://facebook.com/getnooro"
          >
            <Facebook width={50} height={50} />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://tiktok.com/@getnooro"
          >
            <TikTok width={50} height={50} />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/getnooro"
          >
            <Twitter width={50} height={50} />
          </a>
        </Icons>
      </Wrapper>{' '}
    </>
  )
}

export default InstagramFeed

const Wrapper = styled.div`
  padding: 100px 20px;
  box-sizing: border-box;

  /* background: linear-gradient(
    to top,
    #edebe0 0%,
    #dcd0af 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  text-align: center;
  /* padding-bottom: 150px; */

  @media (max-width: ${breakpoints.s}px) {
    padding: 40px 0;
  }
`

const Icons = styled.div`
  margin-top: 50px;

  a {
    color: #215041;
    margin: 0 20px;
  }

  svg {
    fill: currentColor;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  position: relative;
  max-width: 1400px;
  margin: 30px auto 0;

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 20px;
    gap: 15px;
  }
`
